import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { EnumListKey } from '~/data/enums/types';
import { useAllEnums } from '~/data/enums/useAllEnums';

export const useUILabelTranslation = () => {
  const { t } = useTranslation();

  const { getEnums } = useAllEnums();
  const uiLabels = useMemo(() => {
    return getEnums(EnumListKey.UI_LABEL);
  }, [getEnums]);

  const uiLabelTranslation = useCallback(
    (translationKey: string) => {
      // Note: Legacy UI is matching translationKey to Enum description value
      const foundLabel = uiLabels.find(
        ({ description }) => description === translationKey,
      );

      return foundLabel?.name && foundLabel?.name !== translationKey
        ? foundLabel.name
        : t(translationKey);
    },
    [uiLabels, t],
  );

  return {
    uiLabelTranslation,
  };
};
